<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});
const generateItemImage = (multiply, itemSrc) => {
  const base = 69;
  return itemSrc + `/S-${base*multiply}`;
};


</script>

<template>
  <div class="custom-card">
    <!-- Title Section -->
    <div class="title-section" style="overflow: hidden">
      <h3 class="title marquee" style="white-space: nowrap">
        {{ props.data.name }}
      </h3>
    </div>

    <!-- Content Section -->
    <div class="content-section">
      <!-- Left Image Section -->
      <div class="image-section">
        <img
          :src="generateItemImage(3, props.data.imagesource)"
          class="building-image"
          alt="Building"
        />
      </div>

      <!-- Right Icon and Progress Section -->
      <div class="progress-section">
        <!-- Icon and Progress 1 -->
        <div class="progress-row">
          <img src="@/assets/bg/calendar.png" class="icon" alt="Calendar" />
          <div class="progress-bar">
            <div
              class="progress-fill blue"
              :style="{
                width: props.data.constructionplanfact.planpercentage + '%',
              }"
            ></div>
          </div>
          <span class="progress-value percent-blue"
            >{{
              props.data.constructionplanfact.planpercentage.toFixed(2)
            }}%</span
          >
        </div>

        <!-- Icon and Progress 2 -->
        <div class="progress-row">
          <img
            src="@/assets/bg/hammer-and-pick.png"
            class="icon"
            alt="Hammer"
          />
          <div class="progress-bar">
            <div
              class="progress-fill yellow"
              :style="{
                width: props.data.constructionplanfact.factpercentage + '%',
              }"
            ></div>
          </div>
          <span class="progress-value percent-yellow"
            >{{
              props.data.constructionplanfact.factpercentage.toFixed(2)
            }}%</span
          >
        </div>

        <!-- Icon and Progress 3 -->
        <div class="progress-row">
          <img src="@/assets/bg/barrier.png" class="icon" alt="Road" />
          <div class="progress-bar">
            <div
              class="progress-fill red"
              :style="{
                width:
                  props.data.constructionplanfact.deviationpercentage + '%',
              }"
            ></div>
          </div>
          <span class="progress-value percent-red"
            >{{
              props.data.constructionplanfact.deviationpercentage.toFixed(2)
            }}%</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-card {
  display: flex;
  flex-direction: column;
  width: 243px;
  border-radius: 10px;
  color: white;
  padding: 5px 0;
}

.title-section {
  text-align: center;
  padding: 2px 0;
}

.title {
  font-size: 22px;
  padding: 3px;
  margin: 0;
  background: radial-gradient(closest-side, #1bc200, transparent);
}

.content-section {
  display: flex;
  flex-direction: row;
  padding-top: 5px;
}

.image-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.building-image {
  width: 69px;
  height: 72px;
  object-fit: cover;
  border-radius: 5px;
}

.progress-section {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.progress-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.icon {
  margin-right: 10px;
  margin-left: 5px;
}

.progress-bar {
  flex: 1;
  height: 7px;
  background-color: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  margin-right: 15px;
  border: 1px solid white;
}

.progress-fill {
  height: 100%;
  border-radius: 3px;
}

.blue {
  background-color: #0093e5;
}

.yellow {
  background-color: #ffb800;
}

.red {
  background-color: #ff0000;
}

.percent-blue {
  color: #0093e5;
}
.percent-yellow {
  color: #ffb800;
}
.percent-red {
  color: #ff0000;
}

.progress-value {
  font-weight: bold;
  width: 25px;
}

.title-section {
  overflow: hidden;
  width: 100%;
}

.marquee {
  display: inline-block; /* Allow horizontal scrolling */
  animation: marquee 20s linear infinite; /* Adjust duration as needed */
}

@keyframes marquee {
  0% {
    transform: translateX(20%); /* Start position */
    opacity: 1;
  }
  85% {
    transform: translateX(-100%); /* End of scroll */
    opacity: 1;
  }
  95% {
    opacity: 0; /* Briefly hide text */
  }
  100% {
    opacity: 0; /* Keep hidden to create a short delay */
  }
}
</style>
